<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useCarGroupsStore } from '@/stores/car-groups'

function changePage(cursor, dir) {

    const params = {
        'c.limit': 6, 
        'c.direction': dir, 
        'c.cursor': cursor
    }

    carGroupsStore.readCarGroupsCreateList(params).then(result => {
        if(result.cars) {
            dir == 'after' ? 
                pageNumber.value++ : 
                pageNumber.value--
        }
    })
}

const translaterStore   = useTranslaterStore()
const carGroupsStore    = useCarGroupsStore()

const getTranslate                  = computed(() => translaterStore.getTranslate)
const carGroupsCreateList           = computed(() => carGroupsStore.carGroupsCreateList)
const carGroupsCreateListProcess    = computed(() => carGroupsStore.carGroupsCreateListProcess)
const carGroupsCreateListMsg        = computed(() => carGroupsStore.carGroupsCreateListMsg)
const carGroupsCreateProcess        = computed(() => carGroupsStore.carGroupsCreateProcess)
const carGroupsCreateMsg            = computed(() => carGroupsStore.carGroupsCreateMsg)

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const inputSearch = ref('')
const pageNumber = ref(1)

carGroupsStore.readCarGroupsCreateList({ 'c.limit': 6 })

watch(inputSearch, input => {
    input.length > 2 ? 
        carGroupsStore.readCarGroupsCreateList({ 'c.limit': 6, 'c.q': inputSearch.value }) :
        carGroupsStore.readCarGroupsCreateList({ 'c.limit': 6 })
})

</script>

<template>
    <div class="uta-car-groups-create">

        <div class="row mb-4 justify-content-between">
            <div class="col">
                <div class="input-group uta-input__wrapper uta-search">
                    <input 
                        type="text" 
                        class="form-control uta-input__wrapper-input uta-search__input uta-search__input--light"
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = ''"
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = ''">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div 
            v-if="'success' in carGroupsCreateMsg && !carGroupsCreateMsg.success"
            class="my-4 uta-alert uta-alert--danger" 
        >
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carGroupsCreateMsg.text] || carGroupsCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carGroupsStore.setCarGroupsCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div
            v-if="'success' in carGroupsCreateListMsg && !carGroupsCreateListMsg.success" 
            class="my-4 uta-alert uta-alert--danger"
        >
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carGroupsCreateListMsg.text] || carGroupsCreateListMsg.text }}
            </div>
        </div>

        <div class="uta-list">
            <div class="uta-list__item" v-for="(group, index) in carGroupsCreateList.array" :key="index">
                <a 
                    href="#"
                    class="uta-list__item-link"
                    @click="carGroupsStore.createCarGroup({ car: props.uuid, cgroup: group.uuid })"
                >
                    {{ group.name }} 
                    <template v-if="carGroupsCreateProcess">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </template>
                </a>
            </div>
        </div>

        <div class="mt-4 uta-cars__pagination" v-if="carGroupsCreateList.c && (carGroupsCreateList.c.isBefore || carGroupsCreateList.c.isAfter)">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="uta-pagination">
                        <button 
                            :disabled="carGroupsCreateListProcess || !carGroupsCreateList.c.isBefore"
                            class="uta-btn uta-btn--sm uta-pagination__prev" 
                            @click.prevent="changePage(carGroupsCreateList.c.start, 'before')"
                        >
                            <span class="material-icons">
                                navigate_before
                            </span>
                        </button>
                        <div class="uta-pagination__current">
                            {{ pageNumber }}
                        </div>
                        <button 
                            :disabled="carGroupsCreateListProcess || !carGroupsCreateList.c.isAfter"
                            class="uta-btn uta-btn--sm uta-pagination__next" 
                            @click.prevent="changePage(carGroupsCreateList.c.stop, 'after')"
                        >
                            <span class="material-icons">
                                navigate_next
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
